import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00065 15.1663C4.04732 15.1663 0.833984 11.953 0.833984 7.99967C0.833984 4.04634 4.04732 0.833008 8.00065 0.833008C11.954 0.833008 15.1673 4.04634 15.1673 7.99967C15.1673 11.953 11.954 15.1663 8.00065 15.1663ZM8.00065 1.83301C4.60065 1.83301 1.83398 4.59967 1.83398 7.99967C1.83398 11.3997 4.60065 14.1663 8.00065 14.1663C11.4007 14.1663 14.1673 11.3997 14.1673 7.99967C14.1673 4.59967 11.4007 1.83301 8.00065 1.83301Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.1663C7.72667 11.1663 7.5 10.9397 7.5 10.6663V7.33301C7.5 7.05967 7.72667 6.83301 8 6.83301C8.27333 6.83301 8.5 7.05967 8.5 7.33301V10.6663C8.5 10.9397 8.27333 11.1663 8 11.1663Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00065 5.99699C7.91398 5.99699 7.82732 5.97699 7.74732 5.94366C7.66732 5.91033 7.59398 5.86366 7.52732 5.80366C7.46732 5.73699 7.42065 5.67032 7.38732 5.58366C7.35398 5.50366 7.33398 5.41699 7.33398 5.33033C7.33398 5.24366 7.35398 5.15699 7.38732 5.07699C7.42065 4.99699 7.46732 4.92366 7.52732 4.85699C7.59398 4.79699 7.66732 4.75033 7.74732 4.71699C7.90732 4.65033 8.09398 4.65033 8.25398 4.71699C8.33398 4.75033 8.40732 4.79699 8.47398 4.85699C8.53398 4.92366 8.58065 4.99699 8.61398 5.07699C8.64732 5.15699 8.66732 5.24366 8.66732 5.33033C8.66732 5.41699 8.64732 5.50366 8.61398 5.58366C8.58065 5.67032 8.53398 5.73699 8.47398 5.80366C8.40732 5.86366 8.33398 5.91033 8.25398 5.94366C8.17398 5.97699 8.08732 5.99699 8.00065 5.99699Z",
			fill: "#3C3C3C"
		})
	]
});
export default SvgInfo;
